import { env } from './../config/env.js';

const fustControllerEndpoint = `${env}/fust`;

export const fustListEndpiont = fustControllerEndpoint;
export const fustDetailEndpoint = fustControllerEndpoint;
export const fustTypesEndpoint = `${fustControllerEndpoint}/fustsoorten`;
export const fustExcelExportEndpoint = `${fustControllerEndpoint}/excel`;
export const languageEndpoint = `${env}/language`;